export interface UserActions {
  urlIcon: string;
  buttonName: string;
  action: Actions;
}
export enum Actions {
  CREATE_BOOKCLUB = 'createExperience',
}
